
export class AppVersion {

  number!: string;
  commit!: string;
  buildTime!: Date;

  static current: AppVersion = { number: '57', commit: 'addcc5d', buildTime: new Date('2026-03-03T09:53:51.856Z') };
}